import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCallPostParms } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const getPropertyById = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallPostParms({
      url: apiConstants.Property.GET_PROPERTY_BY_ID,
      method: 'post',
      data: data,
      params: data
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
